/* eslint-disable quotes */
import { JsonRpc, JsonRpcResult } from 'node-jsonrpc-client'

import { JsonRpcCall, JsonRpcCallArgs } from '@/interfaces/json-rpc'

const endpoint = process.env.JSON_RPC_ENDPOINT || ''

export const client = new JsonRpc(endpoint)

export const makeCall: JsonRpcCall = async <T>({
  method,
  params
}: JsonRpcCallArgs<T>): Promise<JsonRpcResult<T>> => {
  try {
    const result: JsonRpcResult<T> = await client.call(method as string, params)

    return result
  } catch (err: unknown) {
    const error = err as Error
    throw new Error(`Oops! error has occured: ${error.message}`)
  }
}
